import { api } from './client';
import type { EventInfo } from './types';

export async function getEvents(params?: { id?: string | number }): Promise<EventInfo[]> {
    const { data } = await api.get<{ content?: EventInfo[] }>('/events/list', { params });
    return data.content ?? [];
}

export async function getTodayEvents(host?: string | number): Promise<EventInfo[]> {
    const { data } = await api.get<{ content?: EventInfo[] }>('/events/today', {
        params: host ? { host } : {},
    });
    return data.content ?? [];
}

export async function getAdminEvents(): Promise<EventInfo[]> {
    const { data } = await api.get<{ content?: EventInfo[] }>('/events/admin');
    return data.content ?? [];
}

export interface NewEventPayload {
    title: string;
    location?: string;
    data: Date;
    img_path?: string;
}

export async function addEvent(payload: NewEventPayload) {
    const { data } = await api.post('/events/add', payload);
    return data;
}

/**
 * Payload di modifica: come la creazione, con l'`id` dell'evento.
 *
 * `location` è resa obbligatoria (il backend la richiede e il form la invia
 * sempre), quindi viene tolta dai campi opzionali di `NewEventPayload`.
 */
export interface UpdateEventPayload extends Omit<NewEventPayload, 'location'> {
    id: number;
    location: string;
}

export async function updateEvent(payload: UpdateEventPayload) {
    const { data } = await api.post('/events/update', payload);
    return data;
}

export async function deleteEvent(id: number) {
    const { data } = await api.post('/events/delete', { id });
    return data;
}
